var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ONE-TIME-CODE"},[_c('div',{staticClass:"text-left"},[_c('a',{staticClass:"link-black",on:{"click":_vm.back}},[_c('vk-icon',{staticClass:"c-depot",attrs:{"name":"chevronleft"}}),_vm._v("\n      Back\n    ")],1)]),_c('one-time-code-form',{attrs:{"redirectTo":_vm.redirectTo,"defaultEmail":_vm.email}}),_vm._v("\n  Already have an account?\n  "),_c('router-link',{staticClass:"link",attrs:{"to":{
        name: 'login',
        query: {
          email: _vm.email,
          redirectTo: _vm.redirectTo
        }
      }}},[_vm._v("\n    Sign in with password.\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }